// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';

export const L1NavItemContainer = styled.div`
  padding: 24px 16px;
  border-bottom: 1px solid #e3e3e3;

  @media ${(props) => props.theme.mediaQuery.large} {
    display: none;
  }
`;

export const L1NavItemHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #000;
  font-family: Nunito;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0.16px;
  text-transform: capitalize;
`;

export const L1NavItemContent = styled.ul`
  margin: 24px 0px 0 16px;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
`;
